import React from "react";
import styled from "styled-components";
import AddImage from "./AddImage";
import AddProperty from "./AddProperty";
import DetailProduct from "./DetailProduct";
import ImageProdcut from "./ImageProdcut";
import InventoryDetail from "./InventoryDetail";
import KeyWord from "./KeyWord";
import Toggle from "../../../../core/components/CollapsToggle/Toggle";
import { useState } from "react";
import ImageSelector from "../../Contents/newContent/ImageSelector";
import SeoProduct from "./SeoProduct";
import Button from "../../../Button/Button";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";

import {
  useGetBrandList,
  useAddNewProduct,
} from "../../../../hooks/useContent";
import { errorMessage } from "../../../../utils/message";
import Typography from "../../../Typography/Typography";
import TagGenerator from "../../Contents/newContent/TagGenerator";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

const NewProduct = () => {
  const [NewProduct, setNewProduct] = useState({
    nameProduct: "",
    EnNameProducts: "",
    ArNameProducts: "",
    IdBrand: "",
    IdGender: "",
    DescriptionProducts: "",
    DescriptionEnglishProducts: "",
    DescriptionLanguageProducts: "",
    IdStore: "",
    InventoryStatus: "موجود در انبار",
    numberInStock: "100",
    numberInJeans: "",
    priceProduct: "",
    generalPriceProducts: "",
    photoProducts: "",
    IdFirstCategories: "",
    IdTwoCategories: "",
    IdThreeCategories: "",
    off: "",
    dateTime: "",
    supplier: "",
    IdOccasions: "",
    IdFeatureValues: [],
    altFarsi: [],
    picture_name: [],
  });
  const [newSeoProduct, setSeoProduct] = useState({
    TitleSeo: "",
    EnTitleSeo: "",
    ArTitleSeo: "",
    KeywordSeo: "",
    EnKeywordSeo: "",
    ArKeywordSeo: "",
    DescriptionSeo: "",
    EnDescriptionSeo: "",
    ArDescriptionSeo: "",
    CanonicalTagSeo: "",
    Redirect3xx: "",
  });
  const navigate = useNavigate();
  const [photoProducts, setPhotoImage] = useState("");
  const [childPhoto, setChildPhoto] = useState([]);
  const [IdFeatureValue, setIdFeatureValue] = useState([]);
  const [levelsProperty, setLevelsProperty] = useState({
    level1: { id: -1, name: "انتخاب گزینه" },
    level2: { id: -1, name: "انتخاب گزینه" },
    level3: { id: -1, name: "انتخاب گزینه" },
  });

  const [textEditor, setTextEditor] = useState("");
  const [entextEditor, setEnTextEditor] = useState("");
  const [artextEditor, setArTextEditor] = useState("");

  const {
    mutateAsync: addNewProduct,
    isLoading: loadProductReq,
    isError,
  } = useAddNewProduct();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "numberInJeans") {
      const numberJean = value === "" ? 0 : value;
      const priceProduct =
        NewProduct?.priceProduct === "" ? 0 : NewProduct?.priceProduct;
      const generalPrice = numberJean * priceProduct;
      setNewProduct({
        ...NewProduct,
        generalPriceProducts: generalPrice,
        [name]: value,
      });
      return;
    }

    if (name === "priceProduct") {
      const numberJean =
        NewProduct?.numberInJeans === "" ? 0 : NewProduct?.numberInJeans;
      const priceProduct = value === "" ? 0 : value;
      const generalPrice = numberJean * priceProduct;
      setNewProduct({
        ...NewProduct,
        generalPriceProducts: generalPrice,
        [name]: value,
      });
      return;
    }

    setNewProduct({ ...NewProduct, [name]: value });
  };

  const handleChangeSelect = (e, name) => {
    const { label, value } = e;
    setNewProduct({ ...NewProduct, [name]: value });
  };

  const FormGenerator = () => {
    const parseIds = IdFeatureValue?.map((data) => {
      return data?.level2?.map((idLevel) => {
        return idLevel?.value;
      });
    });

    const parseAlt = childPhoto?.map((item) => {
      return item?.alt;
    });

    const parseChildPhoto = childPhoto?.map((item) => {
      return item?.file;
    });

    let formData = new FormData();
    formData.append("NameProducts", NewProduct?.nameProduct);
    formData.append("EnNameProducts", NewProduct?.EnNameProducts);
    formData.append("ArNameProducts", NewProduct?.ArNameProducts);
    formData.append("IdBrands", NewProduct?.IdBrand);
    formData.append("IdGender", NewProduct?.IdGender);
    formData.append("IdStore", NewProduct?.IdStore);
    formData.append(
      "IdOccasions",
      NewProduct?.IdOccasions ? NewProduct?.IdOccasions : ""
    );
    formData.append("InventoryStatus", NewProduct?.InventoryStatus);
    formData.append("NumberInStock", NewProduct?.numberInStock);
    formData.append("NumberInJeans", NewProduct?.numberInJeans);
    formData.append("PriceProducts", NewProduct?.priceProduct);
    formData.append("GeneralPriceProducts", NewProduct?.generalPriceProducts);
    formData.append("PhotoProducts", photoProducts);
    formData.append("IdFirstCategories", levelsProperty.level1?.id);
    formData.append("IdTwoCategories", levelsProperty.level2?.id);
    formData.append(
      "IdThreeCategories",
      levelsProperty.level3?.id === -1 ? "" : levelsProperty.level3?.id
    );
    formData.append("off", NewProduct?.off);
    formData.append("DateTime", NewProduct?.dateTime);
    formData.append("Supplier", NewProduct?.supplier);
    formData.append("altFarsi", []);
    formData.append("DescriptionProducts", textEditor);
    formData.append("DescriptionEnglishProducts", entextEditor);
    formData.append("DescriptionLanguageProducts", artextEditor);

    for (let i = 0; i < parseIds.length; i++) {
      formData.append(`IdFeatureValues[${i}]`, parseIds[i]);
    }

    for (let i = 0; i < parseAlt.length; i++)
      formData.append(`altFarsi[${i}]`, parseAlt[i]);

    for (let i = 0; i < parseChildPhoto.length; i++)
      formData.append(`picture_name[${i}]`, parseChildPhoto[i]);

    formData.append("TitleSeo", newSeoProduct?.TitleSeo);
    formData.append("EnTitleSeo", newSeoProduct?.EnTitleSeo);
    formData.append("ArTitleSeo", newSeoProduct?.ArTitleSeo);
    formData.append("KeywordSeo", newSeoProduct?.KeywordSeo);
    formData.append("EnKeywordSeo", newSeoProduct?.EnKeywordSeo);
    formData.append("ArKeywordSeo", newSeoProduct?.ArKeywordSeo);
    formData.append("DescriptionSeo", newSeoProduct?.DescriptionSeo);
    formData.append("EnDescriptionSeo", newSeoProduct?.EnDescriptionSeo);
    formData.append("ArDescriptionSeo", newSeoProduct?.ArDescriptionSeo);
    formData.append("CanonicalTagSeo", newSeoProduct?.CanonicalTagSeo);
    formData.append("Redirect3xx", newSeoProduct?.Redirect3xx);
    formData.append("KeyWordsProducts", tags?.join(","));

    addNewProduct(formData).then((res) => {
      navigate("/dashboard/content-controller/products", { replace: true });
    });
  };

  const isValidCollectionPhoto = () => {
    let isExistNotValidItem = false;
    childPhoto.map((item) => {
      if (item?.file?.length < 1) {
        isExistNotValidItem = true;
      }
      return;
    });
    return isExistNotValidItem;
  };

  const isValidCollectionProperty = () => {
    let isExistNotValidItem = false;
    IdFeatureValue?.map((item) => {
      if (item?.level2.length < 1) {
        isExistNotValidItem = true;
      }
      return;
    });

    return isExistNotValidItem;
  };

  const validateForm = () => {
    let occureError = false;

    if (NewProduct?.nameProduct === "") {
      errorMessage("لطفا اسم محصول را وارد نمایید");
      occureError = true;
    }
    if (NewProduct?.IdBrand === "" || NewProduct?.IdBrand === -1) {
      errorMessage("لطفا برند  محصول را انتخاب نمایید");
      occureError = true;
    }
    if (NewProduct?.IdGender === "" || NewProduct?.IdGender === -1) {
      errorMessage("لطفا جنسیت  محصول را انتخاب نمایید");
      occureError = true;
    }
    if (NewProduct?.IdStore === "" || NewProduct?.IdStore === -1) {
      errorMessage("لطفا انبار  محصول را انتخاب نمایید");
      occureError = true;
    }
    if (NewProduct?.numberInJeans === "") {
      errorMessage("لطفا  تعداد محصول در جین را وارد نمایید");
      occureError = true;
    }
    if (NewProduct?.priceProduct === "") {
      errorMessage("لطفا قیمت هر محصول را وارد  نمایید");
      occureError = true;
    }
    if (photoProducts?.length < 1) {
      errorMessage("لطفا عکس محصول را انتخاب نمایید");
      occureError = true;
    }
    if (isValidCollectionPhoto()) {
      errorMessage("لیست  عکس های وارد شده درست نمیاشد");
      occureError = true;
    }
    if (levelsProperty?.level1?.id === -1) {
      errorMessage("لطف دسته بندی سطح یک محصول را انتخاب نمایید");
      occureError = true;
    }
    if (levelsProperty?.level2?.id === -1) {
      errorMessage("لطف دسته بندی سطح دوم محصول را انتخاب نمایید");
      occureError = true;
    }
    if (NewProduct?.supplier === "" || NewProduct?.supplier === -1) {
      errorMessage("لطفا تامین کننده را انتخاب نمایید");
      occureError = true;
    }

    if (isValidCollectionProperty()) {
      errorMessage("ویژگی سطح دوم لیست ویژگی ها را وارد نمایید");
      occureError = true;
    }

    return occureError;
  };

  const handleSubmit = (e) => {
    !validateForm() && FormGenerator();
  };

  const [tags, setTgas] = useState([]);

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        num3="محصول جدید"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/products"
      />
      <NewProductStyle>
        <LeftLayout>
          <Toggle title={"جزییات محصول"}>
            <DetailProduct
              handleChange={handleChange}
              form={NewProduct}
              textEditor={textEditor}
              setTextEditor={setTextEditor}
              entextEditor={entextEditor}
              setEnTextEditor={setEnTextEditor}
              artextEditor={artextEditor}
              setArTextEditor={setArTextEditor}
              handleChangeSelect={handleChangeSelect}
            />
          </Toggle>
          <Toggle show={true} title={"سِو محصول"}>
            <SeoProduct
              newSeoProduct={newSeoProduct}
              setSeoProduct={setSeoProduct}
            />
          </Toggle>
        </LeftLayout>
        <RightLayout>
          <Toggle title={"انبار داری"}>
            <InventoryDetail handleChange={handleChange} form={NewProduct} />
          </Toggle>
          <Toggle title={"تصویر اصلی محصول"}>
            <ImageSelector files={photoProducts} setFiles={setPhotoImage} />
          </Toggle>
          <Toggle title={"افزودن عکس"}>
            <AddImage
              childPhoto={childPhoto}
              NewProduct={NewProduct}
              setChildPhoto={setChildPhoto}
            />
          </Toggle>
          <Toggle title={"دسته بندی محصول"}>
            <AddProperty
              NewProduct={NewProduct}
              setNewProduct={setNewProduct}
              levelsProperty={levelsProperty}
              setLevelsProperty={setLevelsProperty}
              IdFeatureValue={IdFeatureValue}
              setIdFeatureValue={setIdFeatureValue}
            />
          </Toggle>
          <Toggle title={"کلمات کلیدی"}>
            <TagGenerator tags={tags} setTags={setTgas} show={false} />
          </Toggle>
          <Button className={"submit-product-btn"} onclick={handleSubmit}>
            {loadProductReq ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <Typography primary={"#fff"}>ثبت محصول</Typography>
            )}
          </Button>
        </RightLayout>
      </NewProductStyle>
    </>
  );
};

const NewProductStyle = styled.div`
  width: 100%;

  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  column-gap: 1%;
  user-select: none;

  @media screen and (max-width: 1100px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LeftLayout = styled.div`
  width: 68%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  overflow: hidden;
  padding-top: 0;

  @media screen and (max-width: 1100px) {
    width: 100%;
  }
`;

const RightLayout = styled.div`
  width: 30%;
  height: 100%;
  .submit-product-btn {
    background: #009ef7;
    color: #fff;
  }

  @media screen and (max-width: 1100px) {
    width: 100%;
  }
`;

const TitleDiv = styled.div``;

export default NewProduct;
